export const sortParams = (
  { is_locked_interview_question: isLockedInterviewQuestion },
  { is_locked_interview_question: isLockedInterviewQuestionCompare }
) => {
  if (isLockedInterviewQuestion > isLockedInterviewQuestionCompare) return 1;
  if (isLockedInterviewQuestion < isLockedInterviewQuestionCompare) return -1;
  return 0;
};
